class LoginController {
    constructor($state, $stateParams, authService, myBookingService, languageService, cacheService, ReferenceFormatterFilter, CONFIG, helpCentreService) {
        'ngInject';

        this.email = $stateParams.email;
        this.reference = $stateParams.reference;
        this.CONFIG = CONFIG;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.authService = authService;
        this.myBookingService = myBookingService;
        this.languageService = languageService;
        this.cacheService = cacheService;
        this.helpCentreService = helpCentreService;
        this.ReferenceFormatterFilter = ReferenceFormatterFilter;
        // Reset login data to defaults
        this.error = false;
        this.setLoginLang();
        this.test={'%headline_start%': 'test'};
    }

    // Set default lang on sign out and with url params
    setLoginLang() {

        this.languageService.setLanguage(this.$stateParams.locale || null);
        try {
            this.languageService.findLanguageByKey(this.$stateParams.locale || null);
        } catch (e) {
            this.$state.transitionTo('auth.login', {
                locale: 'en',
                reference: this.reference,
                email: this.email
            }, {location: true, notify: false});
        }
    }

    setLanguage() {
        this.languageService.setLanguage(this.cacheService.get('customer').language || null);
    }

    login() {
        let reference = this.ReferenceFormatterFilter(this.reference);
        this.authService.loginByBookingReferenceAndCustomerEmail(reference, this.email)
            .then((response) => {
                //Bookings
                return this.myBookingService.getGlobalInfoBooking(reference).then(response => {
                    this.cacheService.set('customer', response.customer);
                    return response;
                });
            })
            .then((response) => {
                this.cacheService.set('bookingReference', response.booking.reference);
                this.setLanguage();
                
                this.$state.go('bookings.booking.view', {
                    locale: this.cacheService.get('customer').language|| null,
                    bookingReference: response.booking.reference
                });


            })
            .catch(error => {
                //TODO manage the error with new relic
                this.error = true;
                this.authService.logout();
            }).finally(() => {
        });
    }

}

export default LoginController;


// WEBPACK FOOTER //
// ./client/app/routes/auth/login/login.controller.js